'use strict';

var lingojsCore = require('@bookingcom/lingojs-core');

/* This file is auto-generated and should not be edited (see `forms-generate` script in package.json) */
var fakeIndex = 'fakeIndex';
/**
 *
 * Locale | Example output
 * --- | ---
 * `en-gb` | Mon
 * `en-us` | Mon
 * `es` | lun
 *
 * ---
 *
 * Full CDF list: https://office.booking.com/admintranslate/site/translate.html?lang=all&aid=1&tag=/weekday_formatted_date/1/short
 */
var form = 'short';
lingojsCore.registerDynamicTags(lingojsCore.t('weekday_formatted_date', fakeIndex, 'short'));

module.exports = form;
//# sourceMappingURL=index.js.map
